import{gql as a}from"@apollo/client";import{GELADA_ORGANISATION_FRAGMENT as n}from"../../graphql/fragments/geladaOrganisation.fragment.js";const o=a`
  query getGeladaOrganisationsForConnectedUser($shouldIncludeOrganisationLogo: Boolean = false) {
    organisation {
      getGeladaOrganisationsForConnectedUser: getOrganisationsForConnectedUser {
        ...geladaOrganisationFragment
      }
    }
  }

  ${n}
`;export{o as GET_GELADA_ORGANISATIONS_FOR_CONNECTED_USER_QUERY};
//# sourceMappingURL=useGetGeladaOrganisationsForConnectedUser.graphql.js.map
